/**
 * Data view layer
 *
 * Connects the server through the api to the UI components.
 *
 * Methods in this layer serve as an adapter bridge between the server layer in api/ and the view layer in pages/
 * adapting data format to be presented from the server and directing data posts from view to the server.
 *
 * To provide a clean API, the layer utilizes react context API to make the layer easily accessible to any component
 * in the component hierachy
 */
import React, { createContext, useContext } from 'react'
import { api } from '../api'
import toolsApi from './tools'
import jobsApi from './jobs'
import cookiesApi from './cookies'
import authAPI from './auth'
import usersApi from './users'
import UEmailAPI from './uemail'
import jobSchedulerAPI from './scheduler'
import scrapyServerAPI from './scrapy_server'
import TLRAPI from './tlr'
import TitleAPI from './title'

// main data context api
const dataContext = createContext()


/**
 * API Definition for the data layer
 *
 * This module brings together api references for all consumption needs of the views
 */
const dataApi = {
    /**
     * Tools API interaction module
     * @returns ToolsAPI module
     */
    tools: () => toolsApi(api),
    /**
     * Jobs API module
     */
    jobs: () => jobsApi(api),
    cookies: () => cookiesApi(api),
    /** Auth module */
    auth: () => authAPI(),
    /** Users module */
    users: () => usersApi(),
    /** Universe Email module */
    uemail: () => UEmailAPI(),
    /** Jobs Sceduler API module */
    jobsScheduler: () => jobSchedulerAPI(),
    /** Scrapy Server API */
    scrapyServer: () => scrapyServerAPI(),
    /** TLR API */
    tlr: () => TLRAPI(api),
    /** Scrapy Server API */
    titles: () => TitleAPI(api),

}

/**
 * Data API context provider component
 *
 * All children of this component will have access to the data API
 */
export const DataProvider = ({ children }) => {
    const api = dataApi

    return <dataContext.Provider value={api}>{children}</dataContext.Provider>
}


/**
 * Utility method to access the api
 *
 * @returns {dataApi} data API module
 */
export const useData = () => useContext(dataContext)